export default __webpack_public_path__ + "static/media/topbanner.4bc0e823.png";